import type { ReactNode } from 'react';

export interface BenefitItem {
  title: string;
  description: ReactNode;
}

// Master list of all potential benefit items
// Partners can reference these by index in their config
export const ALL_BENEFITS: BenefitItem[] = [
  {
    title: 'Curated Screen',
    description: 'Understand your inherited risk for cancer, heart disease, and more.',
  },
  {
    title: 'Medication Response',
    description: 'Learn how your genes may affect your response to certain medications.',
  },
  {
    title: 'Access to Genetic Counseling',
    description: 'Talk to a licensed expert to better understand your results and next steps.',
  },
  {
    title: 'Coronary Artery Disease Baseline Risk',
    description: 'Learn how your genetics influence your risk for coronary artery disease.',
  },
  {
    title: 'Breast Cancer Baseline Risk',
    description: 'Learn how your genetics influence your risk for breast cancer.',
  },
  {
    title: 'Prostate Cancer Baseline Risk',
    description: 'Learn how your genetics influence your risk for prostate cancer.',
  },
  {
    title: 'Type 2 Diabetes Baseline Risk',
    description: 'Learn how your genetics influence your risk for type 2 diabetes.',
  },
];

// Helper function to get benefits by indexes
export const getBenefitsByIndexes = (indexes: number[]): BenefitItem[] => {
  return indexes.map(index => ALL_BENEFITS[index]).filter(Boolean);
};

// Legacy export for backward compatibility (default benefits for longevity)
export const benefits: BenefitItem[] = [ALL_BENEFITS[0], ALL_BENEFITS[1], ALL_BENEFITS[2]];
